import { render, staticRenderFns } from "./addKeyWordsItem.vue?vue&type=template&id=7935cf37&"
import script from "./addKeyWordsItem.vue?vue&type=script&lang=js&"
export * from "./addKeyWordsItem.vue?vue&type=script&lang=js&"
import style0 from "./addKeyWordsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7935cf37')) {
      api.createRecord('7935cf37', component.options)
    } else {
      api.reload('7935cf37', component.options)
    }
    module.hot.accept("./addKeyWordsItem.vue?vue&type=template&id=7935cf37&", function () {
      api.rerender('7935cf37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/components/addKeyWordsItem.vue"
export default component.exports